import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './Stats.module.scss';

const Stats = () => {
  const [isMounted, setIsMounted] = useState(false);
  const { t } = useTranslation(['marketing']);

  // Prevent hydration issues by not rendering until client-side
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
  <div className={cn(styles.Container, styles.StatsSection)}>
    <div className={styles.Stat}>
      <img src="/img/illustrations/landing/icon-1.svg" alt="Tickets" />
      <h3>{t('landing.stats.transfers.value')}</h3>
      <div className={styles.Title}>
        {t('landing.stats.transfers.label').split('\\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index === 0 && <br />}
          </React.Fragment>
        ))}
      </div>
    </div>
    <div className={styles.Stat}>
      <img src="/img/illustrations/landing/icon-2.svg" alt="Tickets" />
      <h3>{t('landing.stats.tickets.value')}</h3>
      <div className={styles.Title}>
        {t('landing.stats.tickets.label').split('\\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index === 0 && <br />}
          </React.Fragment>
        ))}
      </div>
    </div>
    <div className={styles.Stat}>
      <img src="/img/illustrations/landing/icon-3.svg" alt="Tickets" />
      <h3>{t('landing.stats.events.value')}</h3>
      <div className={styles.Title}>
        {t('landing.stats.events.label').split('\\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index === 0 && <br />}
          </React.Fragment>
        ))}
      </div>
    </div>
    <div className={styles.Stat}>
      <img src="/img/illustrations/landing/icon-4.svg" alt="Tickets" />
      <h3>{t('landing.stats.donations.value')}</h3>
      <div className={styles.Title}>
        {t('landing.stats.donations.label').split('\\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index === 0 && <br />}
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
  );
};

export default Stats;
